<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="900px"
    :title="$l('INDEX.dialog_title_chooseImportTemplate') || title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
  >
    <Main
      ref="main"
      :templateGroup="templateQueryParams.templateGroup"
      @close="close"
      @confirm="confirm"
    />
  </el-dialog>
</template>
<script>
import Main from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { Main },
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '选择导入模版1' },
    templateQueryParams: {
      type: Object,
      default: () => ({ templateGroup: '' }),
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    async confirm({ templateFileCode = '' }) {
      this.$api.SYS_FILEDOWNLOAD(templateFileCode)
      this.$emit('update:visible', false)
    },
  },
}
</script>
